import { httpRequest } from "../../http";


export class CommandDuplicateTemplate{
    async run(templateId: number, folderId: number) {
       
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ad_templates/${templateId}/duplicate/`
            try {
                const response = await httpRequest<any>(url, { method: "POST", body: { folder_id: folderId } });
                if(response) {
                    return response;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

}
